module.exports = __webpack_public_path__ + "media/application/images/ui/purchase/magazine-ec0f185c78c5ff60831ae73df62ee342.jpg";